import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {Faq} from "../models/faq";
import {NovoFaq} from "../models/novo-faq";

@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`FaqService`);
  }

  baseUrl = environment.apiUrl;

  buscarPorTipo(tipo: number): Observable<BaseResponse<Faq[]> | any> {
    return this.http
      .get<BaseResponse<Faq[]>>(`${this.baseUrl}/Faq/BuscarPorSegmento/${tipo}`)
      .pipe(catchError(this.handlerErro<any>('buscarPorTipo')));
  }

  buscarAtivos(): Observable<BaseResponse<Faq[]> | any> {
    return this.http
      .get<BaseResponse<Faq[]>>(`${this.baseUrl}/Faq`)
      .pipe(catchError(this.handlerErro<any>('buscarAtivos')));
  }

  buscarPorId(id: number): Observable<BaseResponse<Faq> | any> {
    return this.http
      .get<BaseResponse<Faq>>(`${this.baseUrl}/Faq/${id}`)
      .pipe(catchError(this.handlerErro<any>('buscarPorId')));
  }

  adicionar(novoFaq: NovoFaq): Observable<BaseResponse<boolean> | any> {
    return this.http
      .post(`${this.baseUrl}/Faq`, novoFaq)
      .pipe(catchError(this.handlerErro<any>('adicionar')));
  }

  buscarMaisAcessados(): Observable<BaseResponse<Faq[]> | any> {
    return this.http
      .get(`${this.baseUrl}/Faq/MaisAcessados`)
      .pipe(catchError(this.handlerErro<any>('buscarMaisAcessados')));
  }

  buscarPorFiltro(filtro: string): Observable<BaseResponse<Faq[]> | any> {
    return this.http
      .post(`${this.baseUrl}/Faq/Filtrar`, { filtro: filtro})
      .pipe(catchError(this.handlerErro<any>('buscarMaisAcessados')));
  }
}
